import { Box, Stack, Typography, useTheme } from '@mui/material'

import { getAgentChatSettings } from '~/features/agents/utils'
import AssistantAvatar from '~/features/chatbot/components/assistantAvatar'
import { store } from '~/store'
import rem from '~/utils/ui'

function Header() {
  const theme = useTheme()

  const chatbotAgent = store((state) => state.chatbot.agent)
  const { chatTitle, chatSubtitle } =
    getAgentChatSettings(chatbotAgent?.chatSettings) || {}

  return (
    <Box>
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={0.5}
        sx={{ padding: rem(12) }}
      >
        <AssistantAvatar
          chatbotImgURL={chatbotAgent.chatbotImgURL}
          variant="xl"
        />
        <Typography
          sx={{
            fontSize: rem(18),
            fontWeight: theme.typography.fontWeightMedium,
            lineHeight: 1.4,
          }}
        >
          {chatTitle || chatbotAgent.businessName}
        </Typography>
        {!!chatSubtitle && (
          <Typography
            sx={{
              fontSize: rem(16),
            }}
          >
            {chatSubtitle}
          </Typography>
        )}
      </Stack>
    </Box>
  )
}

export default Header
